import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { AccountDisinvestmentStrategyClient } from "../../../../../../../../Wrap/Api/Account/AccountDisinvestmentStrategy";
import { ProductOverviewClient } from "../../../../../../../../Wrap/Api/ProductOverview/Charges/ProductOverview";
import { AccountDisinvestmentStrategy } from "../../../../../../../../Wrap/Models/Domains/Account/AccountDisinvestmentStrategy";
import { ProductOverviewChargeDispatcher } from "../Stores/Variable";

export class ProductOverviewChargeAction {
    public static getCharge(hierarchyId: string) {
        const client = new ProductOverviewClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            ProductOverviewChargeDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => {});
    }

    public static getAccountDisinvestmentStrategy(
        hierarchyId: string,
        callBack?: (val: AccountDisinvestmentStrategy) => void
    ) {
        const client = new AccountDisinvestmentStrategyClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => {});
    }

    public static updateAccountDisinvestmentStrategy(obj: AccountDisinvestmentStrategy, callBack?: (val) => void) {
        const client = new AccountDisinvestmentStrategyClient();
        const promise = client.put(obj);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => {});
    }
}
